export enum BadgeSize {
  Xxs = 'badge-xxs',
  Xs = 'badge-xs',
  Sm = 'badge-sm'
}
